import tw, { styled } from 'twin.macro';

const Heading2 = styled.h2`
  ${tw`text-xl md:text-2xl leading-10 font-bold mb-4 text-nIndigo-300`};
  ${tw`print:!text-lg`}
  line-height: 1.3;
`;

export default Heading2;
